export const dashboardTabMeta = {
  id: "dashboard",
  label: "Dashboard",
  shortLabel: "Home",
};
